/* eslint-disable max-lines */
/* eslint-disable max-statements */
import React from 'react'
import { useGlobal } from './GlobalContext'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import { adyenValidaCartao } from '../api/adyen.servico'
import { normalizeNumberString } from '../utils/formatter/formatter'
import { getVendasPorAssinatura } from '../api/assinatura.servico'
import { validateCaptcha, resetCaptcha } from '../utils/recaptcha'

import {
  cadastraNovaDataCobranca,
  listaInfosPagamento
} from '../api/pagamento.servico'
import {
  cadastraCartao,
  cadastraCartaoVigente,
  deletaCartao,
  listaCartoes,
  postAutoCobranca
} from '../api/cartaoCredito.servico'
import { TITULO_ERRO_SALVAR_CARTAO_CREDITO } from '../containers/Modalidade/PagamentoCartaoCredito/constantsPagamentoCartaoCredito'
import LabelVerCartoesCadastrados from '../components/FluxosPagamento/pagamento/LabelVerCartoesCadastrados'
const CartaoCreditoContext = React.createContext()

function CartaoCreditoProvider( props ) {
  const [ state, setState ] = React.useState( {
    'cartaoAdicionado': false,
    'cartaoExcluido': false,
    'cartaoSelecionado': {},
    'cartaoValidado': {},
    'cartaoVigente': {},
    'cartoesCadastrados': null,
    'dataCobrancaModificada': false,
    'errosAutoCobranca': null,
    'errosCadastro': null,
    'errosCartao': {},
    'infosPagamento': {},
    'showAllCreditCards': false,
    'loading': false,
    'sucessoAutoCobranca': null
  } )

  const value = React.useMemo(
    () => {
      return {
        setState,
        state
      }
    },
    [ state ]
  )

  return (
    <CartaoCreditoContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useCartaoCredito() {
  const context = React.useContext( CartaoCreditoContext )

  const { setErroRequisicao, setCaptcha } = useGlobal()

  if ( !context ) {
    throw new Error( 'useCartaoCredito deve ser usado dentro de CartaoCreditoProvider' )
  }

  const { state, setState } = context

  const setCartaoSelecionado = cartaoSelecionado => {
    setState( prevState => ( {
      ...prevState,
      cartaoSelecionado
    } ) )
  }

  const setInfosPagamento = infosPagamento => {
    setState( prevState => ( {
      ...prevState,
      infosPagamento
    } ) )
  }

  const setCartaoAdicionado = cartaoAdicionado => {
    setState( prevState => ( {
      ...prevState,
      cartaoAdicionado
    } ) )
  }

  const setCartaoExcluido = cartaoExcluido => {
    setState( prevState => ( {
      ...prevState,
      cartaoExcluido
    } ) )
  }

  const setCartaoVigente = cartaoVigente => {
    setState( prevState => ( {
      ...prevState,
      cartaoVigente
    } ) )
  }

  const setErrosCartao = errosCartao => {
    setState( prevState => ( {
      ...prevState,
      errosCartao
    } ) )
  }

  const setCartaoValidado = cartaoValidado => {
    setState( prevState => ( {
      ...prevState,
      cartaoValidado
    } ) )
  }

  const setShowAllCreditCards = showAllCreditCards => {
    setState( prevState => ( {
      ...prevState,
      showAllCreditCards
    } ) )
  }

  const setBandeira = bandeira => {
    setState( prevState => ( {
      ...prevState,
      bandeira
    } ) )
  }

  const setSucessoAutoCobranca = sucessoAutoCobranca => {
    setState( prevState => ( {
      ...prevState,
      sucessoAutoCobranca
    } ) )
  }

  const setDataCobrancaModificada = dataCobrancaModificada => {
    setState( prevState => ( {
      ...prevState,
      dataCobrancaModificada
    } ) )
  }

  const setErroAutoCobranca = errosAutoCobranca => {
    setState( prevState => ( {
      ...prevState,
      errosAutoCobranca
    } ) )
  }

  const setErrosCadastro = errosCadastro => {
    setState( prevState => ( {
      ...prevState,
      errosCadastro
    } ) )
  }

  const setListaCartoesCadastrados = cartoesCadastrados => {
    setState( prevState => ( {
      ...prevState,
      cartoesCadastrados
    } ) )
  }

  const setLoading = loading => {
    setState( prevState => ( {
      ...prevState,
      loading
    } ) )
  }

  const setLoadingRemoveCartao = loadingRemoveCartao => {
    setState( prevState => ( {
      ...prevState,
      loadingRemoveCartao
    } ) )
  }

  const getInfosPagamento = async( idAssinatura ) => {
    try {
      const infosPagamentoResponse = await listaInfosPagamento( idAssinatura )
      let infosPagamento = {}

      if ( !isEmptyObject( infosPagamentoResponse.data ) ) {
        infosPagamento = infosPagamentoResponse.data
      }

      try {
        const [ infosPagamentoUltimaVenda ] = await getVendasPorAssinatura( idAssinatura )
        if ( !isEmptyObject( infosPagamentoResponse.data ) && !isEmptyObject( infosPagamentoUltimaVenda ) ) {
          const valorLiquidoSemDesconto = Number( infosPagamentoUltimaVenda.valor_bruto ) + Number( infosPagamentoUltimaVenda.valor_frete )
          const totalDescontos = Number( infosPagamentoUltimaVenda.desconto_geral ) + Number( infosPagamentoUltimaVenda.desconto_frete ) + Number( infosPagamentoUltimaVenda.desconto_kit )
          infosPagamento.valorFrete = Number( infosPagamentoUltimaVenda.valor_frete )
          infosPagamento.valorLiquido = valorLiquidoSemDesconto - totalDescontos
          infosPagamento.parcelas = infosPagamentoUltimaVenda.parcelas
        }
      } catch ( erro ) {
        console.error( erro.stack )
      }

      if ( !isEmptyObject( infosPagamento ) ) {
        setInfosPagamento( infosPagamento )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const getCartoes = async idAssinatura => {
    try {
      const response = await listaCartoes()

      if ( response.data.length ) {
        const cartoes = response.data.filter( item => !item.softDelete )

        setListaCartoesCadastrados( cartoes )

        // eslint-disable-next-line array-callback-return
        response.data.map( item => {
          if ( item.vigencia.assinaturas.includes( idAssinatura ) ) {
            setCartaoVigente( item )
          }
        } )
      } else {
        setListaCartoesCadastrados( [] )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const postCartao = async( cartao, idAssinatura, hideModalProcessamento = null ) => {
    const dadosCartao = {
      'captcha': validateCaptcha(),
      'cartao_credito': cartao,
      'cobrar': false
    }
    setLoading( true )
    try {
      const response = await cadastraCartao( dadosCartao )
      if ( !isEmptyObject( response.data ) ) {
        setLoading( false )
        setCartaoAdicionado( true )
        const oldCards = state.cartoesCadastrados
        const newCards = [ ...oldCards, response.data.cartaoCredito ]
        setListaCartoesCadastrados( newCards )
        if ( hideModalProcessamento ) {
          hideModalProcessamento()
        }
        return response.data
      }
    } catch ( erro ) {
      resetCaptchaToken()
      setLoading( false )
      if ( hideModalProcessamento ) {
        hideModalProcessamento()
      }
      const { response } = erro
      if ( response?.data[ 0 ]?.message ) {
        setErroRequisicao(
          response.status,
          {
            'descricao': response?.data[ 0 ].message,
            'titulo': TITULO_ERRO_SALVAR_CARTAO_CREDITO
          }
        )
      } else if ( response?.data?.errors[ 0 ]?.message ) {
        const temCampoSourceErroCartao = objetoTemPropriedade(
          response?.data?.errors[ 0 ],
          'source'
        )
        const temCampoMessageErroCartao = objetoTemPropriedade(
          response?.data?.errors[ 0 ],
          'message'
        )
        const temMensagemErro = response?.data?.errors[ 0 ].message || ''
        if ( temCampoMessageErroCartao && temCampoSourceErroCartao ) {
          setErroRequisicao(
            response.status,
            {
              'bottomMessage': (
                <LabelVerCartoesCadastrados
                  border
                  setActiveModal={ () => {
                    setShowAllCreditCards( true )
                    setErroRequisicao( false )
                  } }
                />
              ),
              'descricao': temMensagemErro,
              'titulo': TITULO_ERRO_SALVAR_CARTAO_CREDITO
            }
          )
        } else if (
          temCampoMessageErroCartao &&
          !temCampoSourceErroCartao &&
          response.status
        ) {
          setErroRequisicao(
            response.status,
            {
              'descricao': response.data[ 0 ].message,
              'titulo': TITULO_ERRO_SALVAR_CARTAO_CREDITO
            }
          )
        }
      } else {
        setErroRequisicao( response.status )
      }
    }
  }

  const validaCartao = async cartao => {
    const cc = {
      'cvv': cartao.cvv,
      'dt_validade': normalizeNumberString( cartao.vencimento ),
      'nome': cartao.nome,
      'numero': normalizeNumberString( cartao.numero )
    }
    try {
      const response = await adyenValidaCartao( cc )
      if ( response ) {
        setCartaoValidado( response )
      }
    } catch ( erro ) {
      setErrosCartao( erro )
    }
  }

  const getBandeira = async cartao => {
    const cc = {
      'cvv': cartao.cvv,
      'dt_validade': normalizeNumberString( cartao.vencimento ),
      'nome': cartao.nome,
      'numero': normalizeNumberString( cartao.numero )
    }
    try {
      const response = await adyenValidaCartao( cc )
      if ( response ) {
        setBandeira( response.bandeira )
      }
    } catch ( erro ) {
      setBandeira( null )
    }
  }

  const postCartaoVigente = async( cartao, idAssinatura ) => {
    const dadosCartao = {
      'assinatura_id': idAssinatura,
      'cartao_credito': {
        'id': cartao.id
      }
    }

    try {
      setLoading( true )
      await cadastraCartaoVigente( dadosCartao )
      // getCartoes( idAssinatura )
      setCartaoSelecionado( {} )
      setCartaoVigente( cartao )
      setCartaoAdicionado( true )
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    } finally {
      setLoading( false )
    }
  }

  const postNovaDataCobranca = async( idNovaDataCobranca, idAssinatura ) => {
    const idCicloInformado = parseInt(
      idNovaDataCobranca,
      10
    )
    const dados = {
      'assinatura_id': idAssinatura,
      'ciclo_cobranca': idCicloInformado
    }
    try {
      await cadastraNovaDataCobranca( dados )
      getInfosPagamento( idAssinatura )
      setDataCobrancaModificada( true )
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const deleteCartao = async( cartaoId, idAssinatura ) => {
    const cartao = {
      'id': cartaoId,
      idAssinatura
    }

    try {
      setLoadingRemoveCartao( cartaoId )
      await deletaCartao( cartao )
      const oldCards = state.cartoesCadastrados
      const newCards = oldCards.filter( item => item.id !== cartaoId )
      setListaCartoesCadastrados( newCards )
      setCartaoSelecionado( {} )
      setCartaoExcluido( true )
    } catch ( erro ) {
      const message = erro.response.data.errors[ 0 ].message || ''
      const messageErro =
        message === 'Erro ao excluir cartão.'
          ? 'Este cartão está vigente na sua assinatura do outro clube. Não é possível deletá-lo.'
          : 'Erro ao excluir o cartao'
      setErroRequisicao(
        erro.response.status,
        {
          'descricao': messageErro,
          'titulo': 'Houve um erro excluir o cartao!'
        }
      )
    } finally {
      setLoadingRemoveCartao( null )
    }
  }

  const realizarAutoCobranca = async( CVV, idAssinatura ) => {
    try {
      setLoading( true )
      await postAutoCobranca(
        CVV,
        idAssinatura
      )
      getInfosPagamento( idAssinatura )
      setSucessoAutoCobranca( true )
    } catch ( erro ) {
      if ( erro.response?.data?.errors?.length ) {
        const [ { message } ] = erro.response.data.errors

        const simpleMessage = [
          'Não foi possível efetuar o pagamento. Por favor, verifique seus dados e tente novamente.',
          'Transação não permitida. Por favor, tente com outro cartão de crédito.',
          'Transação recusada. Por favor, verifique seus dados e tente novamente.',
          'Cartão inválido. Adicione um novo cartão antes de prosseguir ou entre em contato.'
        ]
        if ( message === 'CVV inválido.' ) {
          setErroAutoCobranca( { message, 'typeError': 'cvv' } )
        } else if ( simpleMessage.includes( message ) ) {
          setErroAutoCobranca( { message, 'typeError': 'cartaoInvalido' } )
        } else {
          setErroAutoCobranca( {
            'message': `Seu cartão apresentou o seguinte problema: \n\n${message}\n\nPara solucionar, adicione um novo cartão e logo em seguida torne-o como vigente na tela anterior.`,
            'typeError': 'cartaoInvalido'
          } )
        }
      } else {
        setErroAutoCobranca( {
          'message':
            'Erro na aplicação. Por favor, entre em contato pelo email contato@taglivros.com.br',
          'typeError': 'undefined'
        } )
      }
    } finally {
      setLoading( false )
    }
  }

  const resetCaptchaToken = () => {
    resetCaptcha()
    setCaptcha( null )
  }

  return {
    'bandeira': state.bandeira,
    'cartaoAdicionado': state.cartaoAdicionado,
    'cartaoExcluido': state.cartaoExcluido,
    'cartaoSelecionado': state.cartaoSelecionado,
    'cartaoValidado': state.cartaoValidado,
    'cartaoVigente': state.cartaoVigente,
    'cartoesCadastrados': state.cartoesCadastrados,
    'dataCobrancaModificada': state.dataCobrancaModificada,
    deleteCartao,
    'errosAutoCobranca': state.errosAutoCobranca,
    'errosCadastro': state.errosCadastro,
    'errosCartao': state.errosCartao,
    getBandeira,
    getCartoes,
    getInfosPagamento,
    'infosPagamento': state.infosPagamento,
    'loading': state.loading,
    'loadingRemoveCartao': state.loadingRemoveCartao,
    postCartao,
    postCartaoVigente,
    postNovaDataCobranca,
    realizarAutoCobranca,
    setCartaoAdicionado,
    setCartaoExcluido,
    setCartaoSelecionado,
    setDataCobrancaModificada,
    setErroAutoCobranca,
    setErrosCadastro,
    setErrosCartao,
    setLoadingRemoveCartao,
    setShowAllCreditCards,
    setSucessoAutoCobranca,
    'showAllCreditCards': state.showAllCreditCards,
    'sucessoAutoCobranca': state.sucessoAutoCobranca,
    validaCartao
  }
}

export { CartaoCreditoProvider, useCartaoCredito }
